<template>
  <div>
    <loading v-show="showLoader" />

    <div class="ib-main-section">
      <div class="container">
        <router-link class="ib-back-btn" :to="{ name: 'Claims' }">Back</router-link>
        <div class="row">
          <div class="col-md-6 pl-0">

          </div>

          <div class="col-md-6 in-page-infographic">
            <img class="img-fluid" alt="icon" :src="require('@/assets/images/claim-policy-right-img.svg')" />
          </div>
        </div>
      </div>


      <div class="container-fluid ib-acquisition-bg">
        <div class="container ib-p-0">
          <div class="container multistep-box listing-design-fixed">
            <!-- flower for box -->
            <img class="img-fluid in-flower-for-box" alt="icon" :src="require('@/assets/images/flower-for-box.svg')" />
            <!-- flower for box -->
            <div class="nav d-flex nav-pills primary-color jbl-progressbar-container" id="v-pills-tab" role="tablist" aria-orientation="vertical" style="justify-content:center !important; position: relative; top: 2rem;">
              <a style="pointer-events: none; display: none" class="nav-link nav-link-local jbl-progressbar-left nav-link-quotation active" id="v-pills-home-tab" data-toggle="pill" href="#v-pills-home" role="tab" aria-controls="v-pills-home" aria-selected="true"><img id="step_1" :src="require('@/assets/images/claim-1-select.svg')"><img style="display: none" id="step_1_hover" :src="require('@/assets/images/claim-1-select.svg')"><span>Upload Information</span></a>
              <a style="pointer-events: none; display: none" class="nav-link nav-link-local jbl-progressbar-left nav-link-quotation" id="v-pills-messages-tab" data-toggle="pill" href="#v-pills-messages" role="tab" aria-controls="v-pills-messages" aria-selected="false"><div class="jbl-progress-icon"><img id="step_3" :src="require('@/assets/images/claim-2.svg')"> <img style="display: none" id="step_3_hover" :src="require('@/assets/images/claim-2-select.svg')"><span>Claim Form</span></div></a>
              <a style="pointer-events: none; display: none" class="nav-link nav-link-local jbl-progressbar-left nav-link-quotation" id="v-pills-settings-tab" data-toggle="pill" href="#v-pills-settings" role="tab" aria-controls="v-pills-settings" aria-selected="false"><div class="jbl-progress-icon"><img id="step_4" :src="require('@/assets/images/claim-3.svg')"> <img style="display: none" id="step_4_hover" :src="require('@/assets/images/claim-3-select.svg')"><span>Upload Info &amp; Documents</span></div></a>
              <a style="pointer-events: none; display: none" class="nav-link nav-link-local jbl-progressbar-left nav-link-quotation" id="v-pills-upload-doc" data-toggle="pill" href="#v-pills-odc" role="tab" aria-controls="v-pills-settings" aria-selected="false"><div class="jbl-progress-icon"><img id="step_5" :src="require('@/assets/images/claim-4.svg')"> <img style="display: none" id="step_5_hover" :src="require('@/assets/images/claim-4-select.svg')"><span>Summary Detail</span></div></a>
              <img class="img-fluid" v-if="step_1" :src="require('@/assets/images/claim-step-1.svg')">
              <img class="img-fluid" v-if="step_2" :src="require('@/assets/images/claim-step-2.svg')">
              <img class="img-fluid" v-if="step_3" :src="require('@/assets/images/claim-step-3.svg')">
              <img class="img-fluid" v-if="step_4" :src="require('@/assets/images/claim-step-4.svg')">
            </div>

            <div v-show="mainArea" class="row mb-4">

              <hr><br>
              <div class="d2c-class-container in-subclass-bb" style="padding-top: 57px; position:relative; padding-bottom: 9px;" v-if="TypeArea">
                <hr class="ib-dotted-hr" style="margin-bottom: 0px !important; position: absolute; top: 27px;">
                <ul role="tablist" class="nav nav-tabs ib-nav-tabs">
                  <li class="nav-item" v-for="(claim_type, key) in claim_types" v-on:click="setType(claim_type.id, )">
                    <a class="nav-link class-box" :class="selected_claim_type == claim_type.id ? 'active' : ''">
                      <img alt="icon" :src="claim_type.image">
                      <h4 class="class-name class-buy">{{ claim_type.text }}</h4>
                    </a>
                  </li>
                </ul>
              </div>
              <!-- <div class="col-md-6 pl-0 d-none" v-else>
              </div> -->
              <hr>
              <div class="container tab-content data-row" id="v-pills-tabContent" style="border: 0; box-shadow: none; background-color:transparent !important;">
                <div class="tab-pane fade show active" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">
                  <div class="row">
                    <h2 class="ib-claim-listing pl-3">Policy Listing</h2>
                    <div class="col-md-12">
                      <div>
                        <hr class="ib-dotted-hr" style="width:100% !important;">
                        <div class="row mb-4">
                          <div class="col-md-12">
                            <div class="listing-nav">
                              <div class="d2c-main-classes">
                                <button class="d2c-class-btn" :class="MajorClass == major_class ? 'active' : ''" v-for="(major_class, key) in major_classes" @click="LoadClaims(major_class)">
                                  <div class="in-right-border" style="text-transform: capitalize;">
                                    {{  major_class.replace(/_/g," ") }}
                                  </div>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="col-md-12 d-none d-md-block">
                          <table class="claim-listing">
                            <tbody>
                            <tr v-for="customer_claim in customer_claims" v-on:click="set_quotation_id(customer_claim.id, customer_claim.consumer_status, customer_claim.risk_id, customer_claim)">
                              <td class="jbl-responsive-td data-img">
                                <div class="in-listing-img">
                                  <img alt="icon" class="img-fluid" :src="customer_claim.product_image"/>
                                  <div class="position-relative-box">
                                    <img alt="icon" class="img-fluid small-icon" :src="customer_claim.company_logo_path">
                                  </div>
                                </div>
                              </td>
                              <td class="jbl-table-heading jbl-responsive-td">{{ customer_claim.subclass_name }}&nbsp;<small style="color: #ef7c94;">{{ customer_claim.product_name }}</small></td>
                              <td class="jbl-responsive-td" v-if="customer_claim.policy_no != null">
                                <div class="jbl-flex-td">
                                  <div class="jbl-date-td jbl-date-heading">Policy No</div>
                                  <div class="jbl-date-td">{{ customer_claim.policy_no}}</div>
                                </div>
                              </td>
                              <td class="jbl-responsive-td">
                                <div class="jbl-flex-td">
                                  <div class="jbl-date-td jbl-date-heading">Status</div>
                                  <div class="ib-status" :class=" customer_claim.consumer_status +'-status'">{{ customer_claim.consumer_status }}</div>
                                </div>
                              </td>
                              <td class="jbl-responsive-td"><router-link :to="{ name: 'ClaimsView', params: { id: customer_claim.id } }" class="nex-Page-Link"><i class="fa fa-chevron-right"></i></router-link></td>
                            </tr>
                            </tbody>
                          </table>
                        </div>

                        <!-- mobile view -->
                        <div class="col-md-12 d-md-none">
                          <div class="d-flex in-sm-listing" v-for="customer_claim in customer_claims" v-on:click="set_quotation_id(customer_claim.id, customer_claim.consumer_status, customer_claim.risk_id, customer_claim)">
                            <div class="in-sm-firstdiv">
                              <div class="in-listing-img in-sm-height">
                                <img class="img-fluid" :src="customer_claim.product_image"/>
                                <div class="position-relative-box">
                                  <img alt="icon" class="img-fluid small-icon" :src="customer_claim.company_logo_path"/>
                                </div>
                              </div>
                            </div>
                            <div class="in-sm-flex1">
                              <!-- <div class="d-flex in-sm-date">
                                <div>Intimation Date:&nbsp;</div>
                                <div>{{ formatDate(self_claim.created_at) }}</div>
                              </div> -->
                              <div class="in-sm-title">{{ customer_claim.subclass_name }}&nbsp;<small style="color: #ef7c94;">{{ customer_claim.product_name }}</small>
                                <!-- <small>{{ self_claim.product_name }}</small>
                                <small class="ib-card-plan">{{ self_claim.plan_name }}</small> -->
                              </div>
                              <!-- <div class="in-sm-title" v-else>{{ self_claim.subclass_name }}
                                <small class="ib-card-plan">{{ self_claim.product_name }}</small>
                              </div> -->
                              <div>
                                <div class="d-flex">
                                  <div class="in-sm-property">Policy No</div>
                                  <div class="in-sm-value">{{ customer_claim.policy_no}}</div>
                                </div>
                              </div>
                              <!-- <div class="">
                                <div class="d-flex">
                                  <div class="in-sm-value ib-td-currency">PKR <span>{{ priceFormatter(self_claim.paid_amount) }}</span></div>
                                </div>
                              </div>
                                <div class="in-sm-status ib-status" :class=" self_claim.status +'-status'">{{ self_claim.status }}</div> -->
                            </div>
                          </div>
                        </div>
                        <!-- mobile view -->

                        <div class="mt-5">
                          <button class="ib-btn-primary ib-btn-width ib-btn-hover" v-if="Object.keys(claim_types).length !== 0" v-on:click="next_step(1)">CONTINUE</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="tab-pane fade" id="v-pills-messages" role="tabpanel" aria-labelledby="v-pills-messages-tab">
                  <div class="container">
                    <div class="row" v-if="nav_link === 0">
                      <div class="col-md-12">
                        <h2 class="ib-claim-listing mb-3">{{ form_name.replace(/_/g,' ') }}</h2>
                        <form v-on:submit="submitClaimForm" id="custom_form">
                          <!-- TypeForm 1 -->
                          <div class="container px-0">
                            <div class="row">
                              <div class="col-md-6" :style="(typeform1 == false) ? {'display' : 'none'} : {'display' : 'block'}"  v-for="field in form_fields">
                                <div class="form-group" v-if="field.type == 'dropdown'">
                                  <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}</label>
                                  <div class="floating-label">
                                    <select style="width: 100% !important;" class="floating-select" :name="field.field_name" onclick="this.setAttribute('value', this.value);" value="">
                                      <option v-for="(value, index) in field.default_values" :value="value.id" :key="index">{{value.text}}</option>
                                    </select>
                                    <span class="highlight"></span>
                                    <div class="ib-custom-select"></div>
                                  </div>
                                </div>

                                <div v-else-if="field.type == 'textBox'">
                                  <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}</label>
                                  <div class="jbl-field">
                                    <input :type="field.type" class="jbl-dynamic-input" :name="field.field_name" v-model="claim_details" :placeholder="'Enter '+ field.label" required>
                                  </div>
                                </div>

                                <div v-else-if="field.type == 'date'">
                                  <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}</label>
                                  <div class="jbl-field">
                                    <input :type="field.type" class="jbl-dynamic-input" :max="formatDate(field.max_date)" :min="formatDate(field.min_date)" :name="field.field_name"  :placeholder="'Enter ' + field.label" required>
                                  </div>
                                </div>

                                <div class="" v-else-if="field.type == 'checkbox'">
                                  <label class="jbl-checkbox-container">{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}
                                    <input value="1" type="checkbox" :name="field.field_name">
                                    <span class="checkmark"></span>
                                  </label>
                                </div>

                                <div v-else-if="field.type == 'textArea'">
                                  <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}</label>
                                  <div class="jbl-field">
                                    <textarea class="jbl-dynamic-input" v-model="claim_details"  :name="field.field_name" :placeholder="'Enter ' + field.label" required></textarea>
                                  </div>
                                </div>

                                <div class="col-md-12" v-else-if="field.type == 'radio'">
                                  <label class="jbl-radio-container">{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}
                                    <input value="1" type="radio" :name="field.field_name">
                                    <span class="checkmark"></span>
                                  </label>
                                </div>
                                <div class="mt-5"></div>
                              </div>
                            </div>
                          </div>
                          <!-- TypeForm 1 -->
                          <!--  TypeForm 2 -->
                          <div v-if="typeform2">
                            <div class="container" v-if="selectedPolicy.subclass_name !== undefined && selectedPolicy.subclass_name.toLowerCase() != 'motor cycle'">
                              <h2 class="upload-title">Upload Images</h2>
                              <div class="row">
                                <div class="col-md-7 order-2 order-md-1 pt-4 pt-md-0">
                                  <div class="image-gallery">
                                    <div class="image-gallery-row">
                                      <div>
                                        <div class="image-gallery-box">
                                          <img class="img-fluid img-preview"  id="_frontRight" :src="stepThreeMotorImagesPath['frontRight']" alt="Image Preview">
                                        </div>
                                        <div v-if="stepThreeMotorImagesErrors.filter(x => x.field == 'frontRight').length > 0" class="mt-3 pl-2">
                                          <!--                                        <div>-->
                                          <!--                                          <small class="text-danger">{{stepThreeMotorImagesErrors.filter(x => x.field == 'frontRight')[0].message}}</small>-->
                                          <!--                                        </div>-->
                                        </div>
                                      </div>
                                      <div>
                                        <div class="image-gallery-box">
                                          <img class="img-fluid img-preview"  id="_frontCenter" :src="stepThreeMotorImagesPath['frontCenter']" alt="Image Preview">
                                        </div>
                                        <div v-if="stepThreeMotorImagesErrors.filter(x => x.field == 'frontCenter').length > 0" class="mt-3 pl-2">
                                          <!--                                        <div>-->
                                          <!--                                          <small class="text-danger">{{stepThreeMotorImagesErrors.filter(x => x.field == 'frontCenter')[0].message}}</small>-->
                                          <!--                                        </div>-->
                                        </div>
                                      </div>
                                      <div>
                                        <div class="image-gallery-box">
                                          <img class="img-fluid img-preview"  id="_frontLeft" :src="stepThreeMotorImagesPath['frontLeft']" alt="Image Preview">
                                        </div>
                                        <div v-if="stepThreeMotorImagesErrors.filter(x => x.field == 'frontLeft').length > 0" class="mt-3 pl-2">
                                          <!--                                        <div>-->
                                          <!--                                          <small class="text-danger">{{stepThreeMotorImagesErrors.filter(x => x.field == 'frontLeft')[0].message}}</small>-->
                                          <!--                                        </div>-->
                                        </div>
                                      </div>
                                    </div>
                                    <div class="image-gallery-row">
                                      <div>
                                        <div class="image-gallery-box">
                                          <img class="img-fluid img-preview" id="_centerRight" :src="stepThreeMotorImagesPath['centerRight']" alt="Image Preview">
                                        </div>
                                        <div v-if="stepThreeMotorImagesErrors.filter(x => x.field == 'centerRight').length > 0" class="mt-3 pl-2">
                                          <!--                                        <div>-->
                                          <!--                                          <small class="text-danger">{{stepThreeMotorImagesErrors.filter(x => x.field == 'centerRight')[0].message}}</small>-->
                                          <!--                                        </div>-->
                                        </div>
                                      </div>
                                      <div>
                                        <div class="image-gallery-box">
                                          <img class="img-fluid img-preview" id="_centerTop" :src="stepThreeMotorImagesPath['centerTop']" alt="Image Preview">
                                        </div>
                                        <div v-if="stepThreeMotorImagesErrors.filter(x => x.field == 'centerTop').length > 0" class="mt-3 pl-2">
                                          <!--                                        <div>-->
                                          <!--                                          <small class="text-danger">{{stepThreeMotorImagesErrors.filter(x => x.field == 'centerTop')[0].message}}</small>-->
                                          <!--                                        </div>-->
                                        </div>
                                      </div>
                                      <div>
                                        <div class="image-gallery-box">
                                          <img class="img-fluid img-preview" id="_centerLeft" :src="stepThreeMotorImagesPath['centerLeft']" alt="Image Preview">
                                        </div>
                                        <div v-if="stepThreeMotorImagesErrors.filter(x => x.field == 'centerLeft').length > 0" class="mt-3 pl-2">
                                          <!--                                        <div>-->
                                          <!--                                          <small class="text-danger">{{stepThreeMotorImagesErrors.filter(x => x.field == 'centerLeft')[0].message}}</small>-->
                                          <!--                                        </div>-->
                                        </div>
                                      </div>
                                    </div>
                                    <div class="image-gallery-row">
                                      <div>
                                        <div class="image-gallery-box">
                                          <img class="img-fluid img-preview" id="_rearRight" :src="stepThreeMotorImagesPath['rearRight']" alt="Image Preview">
                                        </div>
                                        <div v-if="stepThreeMotorImagesErrors.filter(x => x.field == 'rearRight').length > 0" class="mt-3 pl-2">
                                          <!--                                        <div>-->
                                          <!--                                          <small class="text-danger">{{stepThreeMotorImagesErrors.filter(x => x.field == 'rearRight')[0].message}}</small>-->
                                          <!--                                        </div>-->
                                        </div>
                                      </div>
                                      <div>
                                        <div class="image-gallery-box">
                                          <img class="img-fluid img-preview" id="_rearCenter" :src="stepThreeMotorImagesPath['rearCenter']" alt="Image Preview">
                                        </div>
                                        <div v-if="stepThreeMotorImagesErrors.filter(x => x.field == 'rearCenter').length > 0" class="mt-3 pl-2">
                                          <!--                                        <div>-->
                                          <!--                                          <small class="text-danger">{{stepThreeMotorImagesErrors.filter(x => x.field == 'rearCenter')[0].message}}</small>-->
                                          <!--                                        </div>-->
                                        </div>
                                      </div>
                                      <div>
                                        <div class="image-gallery-box">
                                          <img class="img-fluid img-preview" id="_rearLeft" :src="stepThreeMotorImagesPath['rearLeft']" alt="Image Preview">
                                        </div>
                                        <div v-if="stepThreeMotorImagesErrors.filter(x => x.field == 'rearLeft').length > 0" class="mt-3 pl-2">
                                          <!--                                        <div>-->
                                          <!--                                          <small class="text-danger">{{stepThreeMotorImagesErrors.filter(x => x.field == 'rearLeft')[0].message}}</small>-->
                                          <!--                                        </div>-->
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-5 order-1 order-md-2 mb-3">
                                  <div class="container mx-auto ib-car-bg">
                                    <div class="row">
                                      <div class="col-4">
                                        <div class="input-btn-width input-first-btn">
                                          <input id="frontRight" type="file" accept="image/*" name="images[]" @change="uploadStepThreeMotorImages($event, 'frontRight')" class="css-checkbox">
                                          <label for="frontRight" class="css-label-checked" v-if="stepThreeMotorImages['frontRight'].length > 0" style="font-size:20px !important;">&check;</label>
                                          <label for="frontRight" class="css-label" v-else>&#43;</label>
                                        </div>
                                      </div>
                                      <div class="col-4">
                                        <div class="input-btn-width input-second-btn">
                                          <input id="frontCenter" type="file" accept="image/*" name="images[]" @change="uploadStepThreeMotorImages($event, 'frontCenter')" class="css-checkbox">
                                          <label for="frontCenter" class="css-label-checked" v-if="stepThreeMotorImages['frontCenter'].length > 0" style="font-size:20px !important;">&check;</label>
                                          <label for="frontCenter" class="css-label" v-else>&#43;</label>
                                        </div>
                                      </div>
                                      <div class="col-4">
                                        <div class="input-btn-width input-third-btn">
                                          <input id="frontLeft" type="file" accept="image/*" name="images[]" @change="uploadStepThreeMotorImages($event, 'frontLeft')" class="css-checkbox">
                                          <label for="frontLeft" class="css-label-checked" v-if="stepThreeMotorImages['frontLeft'].length > 0" style="font-size:20px !important;">&check;</label>
                                          <label for="frontLeft" class="css-label" v-else>&#43;</label>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-4">
                                        <div class="input-btn-width input-forth-btn">
                                          <input id="centerRight" type="file" accept="image/*" name="images[]" @change="uploadStepThreeMotorImages($event, 'centerRight')" class="css-checkbox">
                                          <label for="centerRight" class="css-label-checked" v-if="stepThreeMotorImages['centerRight'].length > 0" style="font-size:20px !important;">&check;</label>
                                          <label for="centerRight" class="css-label" v-else>&#43;</label>
                                        </div>
                                      </div>
                                      <div class="col-4">
                                        <div class="input-btn-width input-fifth-btn">
                                          <input id="centerTop" type="file" accept="image/*" name="images[]" @change="uploadStepThreeMotorImages($event, 'centerTop')" class="css-checkbox">
                                          <label for="centerTop" class="css-label-checked" v-if="stepThreeMotorImages['centerTop'].length > 0" style="font-size:20px !important;">&check;</label>
                                          <label for="centerTop" class="css-label" v-else>&#43;</label>
                                        </div>
                                      </div>
                                      <div class="col-4">
                                        <div class="input-btn-width input-sixth-btn">
                                          <input id="centerLeft" type="file" accept="image/*" name="images[]" @change="uploadStepThreeMotorImages($event, 'centerLeft')" class="css-checkbox">
                                          <label for="centerLeft" class="css-label-checked" v-if="stepThreeMotorImages['centerLeft'].length > 0" style="font-size:20px !important;">&check;</label>
                                          <label for="centerLeft" class="css-label" v-else>&#43;</label>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-4">
                                        <div class="input-btn-width input-seventh-btn">
                                          <input id="rearRight" type="file" accept="image/*" name="images[]" @change="uploadStepThreeMotorImages($event, 'rearRight')" class="css-checkbox">
                                          <label for="rearRight" class="css-label-checked" v-if="stepThreeMotorImages['rearRight'].length > 0" style="font-size:20px !important;">&check;</label>
                                          <label for="rearRight" class="css-label" v-else>&#43;</label>
                                        </div>
                                      </div>
                                      <div class="col-4">
                                        <div class="input-btn-width input-eighth-btn">
                                          <input id="rearCenter" type="file" accept="image/*" name="images[]" @change="uploadStepThreeMotorImages($event, 'rearCenter')" class="css-checkbox">
                                          <label for="rearCenter" class="css-label-checked" v-if="stepThreeMotorImages['rearCenter'].length > 0" style="font-size:20px !important;">&check;</label>
                                          <label for="rearCenter" class="css-label" v-else>&#43;</label>
                                        </div>
                                      </div>
                                      <div class="col-4">
                                        <div class="input-btn-width input-ninth-btn">
                                          <input id="rearLeft" type="file" accept="image/*" name="images[]" @change="uploadStepThreeMotorImages($event, 'rearLeft')" class="css-checkbox">
                                          <label for="rearLeft" class="css-label-checked" v-if="stepThreeMotorImages['rearLeft'].length > 0" style="font-size:20px !important;">&check;</label>
                                          <label for="rearLeft" class="css-label" v-else>&#43;</label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="container" v-else>
                              <div class="row text-center ib-default-flex">

                                <div class="col-12 text-center">
                                  <label class="" :for="'generic-images-1'" :class="stepThreeMotorImages.length < 1 ? '' : 'ib-generic-label'">
                                    <div class="">
                                      <img class="img-fluid my-3 py-2" :src="require('@/assets/images/add-room.svg')" alt="icon" v-if="stepThreeMotorImages.length < 1">
                                      <div class="second-upload-btn" :class="stepThreeMotorImages.length < 1 ? '' : 'w-100'">
                                        <div class="jbl-browse-text">
                                          <div>
                                            <img :src="require('@/assets/images/upload-images.svg')" alt="">
                                          </div>
                                          <div>Upload Images</div>
                                        </div>
                                      </div>
                                    </div>
                                  </label>

                                  <input style="display: none" :id="'generic-images-1'"
                                         type="file"
                                         multiple
                                         accept="image/*"
                                         @change="uploadStepThreeBikeImages($event)"
                                         onclick="this.value=null"
                                  />
                                </div>
                                <div class="col-md-3" v-for="(image, index) in stepThreeMotorImages" :key=" index">
                                  <div class="document-list">
                                    <div class="">
                                              <span>
                                                <img class="doc-remove-icon" @click="removeStepThreeBikeImages(index)" :src="require('@/assets/images/ib-upload-remove-icon.svg')"></span>
                                    </div>
                                    <span class="document-list-title document-list-title2" style="height:100% !important;"><img class="img-fluid custom-w-m" :src="require('@/assets/images/text-document.svg')"> Image {{ index+1 }}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!--  TypeForm 2 -->
                          <div class="mt-5 in-flex-550">
                            <span v-show="back_btn"  v-on:click="next_step(0)"  class="ib-btn-primary ib-btn-width ib-btn-hover ib-btn-outline mr-3">PREVIOUS</span>
                            <input type="submit"  v-if="typeSubmit && nav_link == 1" class="ib-btn-primary ib-btn-width ib-btn-hover" @click="next_step(1)" value="CONTINUE">
                            <input type="submit"  v-if="typeSubmit && nav_link == 0 " class="ib-btn-primary ib-btn-width ib-btn-hover" @click="next_step(1)" value="CONTINUE">
                            <button v-show="typeSubmitTemp && nav_link == 1" class="ib-btn-primary ib-btn-hover ib-btn-width" @click="ShowNextForm">Next</button>
                            <button v-show="typeSubmitTemp && nav_link == 0" class="ib-btn-primary ib-btn-hover ib-btn-width" @click="ShowNextForm">Next</button>

                            <!--                            </span>-->
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tab-pane fade" id="v-pills-settings" role="tabpanel" aria-labelledby="v-pills-settings-tab">
                  <!-- Documents upload here-->
                  <div class="col-12 upload-b-container" v-if="documents.length > 0 && nav_link === 1">
                    <div class="upload-b-bottom" v-for="(doc_field, up_key) in doc_fields" :key="up_key">
                      <div>
                        <h4 class="ib-upload-heading">{{ doc_field.label}}<span> *</span></h4>
                      </div>
                      <div class="container">
                        <div class="row text-center ib-default-align">
                          <div class="col-md-3" v-for="(image, key) in doc_files[doc_field.field_name]" :key="key" >

                            <div class="document-list">
                              <div class="">
                                <span><img class="doc-remove-icon" v-on:click="removeUploadedFile(image,doc_field.field_name)" :src="require('@/assets/images/ib-upload-remove-icon.svg')" @click="removeStepThreeUploadedImage(index, element.field_name)"></span>
                              </div>
                              <span class="document-list-title"><img :src="require('@/assets/images/text-document.svg')"> Document {{ key+1 }}</span>
                            </div>
                          </div>
                          <div key="key1" class="col-md-3">
                            <label class="" :for="doc_field.field_name" style="cursor: pointer">
                              <div class="">
                                <div class="ib-upload-btn">
                                  <div class="jbl-browse-text"></div>
                                </div>
                              </div>
                            </label>
                            <input style="display: none"  :name="doc_field.field_name" :id="doc_field.field_name"
                                   type="file"
                                   multiple
                                   accept="image/*"
                                   @change="uploadImage($event,doc_field.field_name)"
                                   onclick="this.value=null"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Documents upload here-->
                  <div class="mt-5 in-flex-550">
                    <span v-show="back_btn"  v-on:click="next_step(0)" class="ib-btn-primary ib-btn-width ib-btn-hover ib-btn-outline mr-3">PREVIOUS</span>
                    <button class="ib-btn-primary ib-btn-width ib-btn-hover" v-if="nav_link == 1" v-on:click="submit_form_data(1)">CONTINUE</button>
                  </div>
                </div>
                <div class="tab-pane fade" id="v-pills-doc" role="tabpanel" aria-labelledby="v-pills-upload-doc">
                  <div class="mt-5" >
                    <button class="ib-btn-primary ib-btn-width ib-btn-hover">CONTINUE</button>
                    <a class="ib-btn-outline ib-btn-width ib-btn-hover" :href="document_link" target="_blank">View Document</a>
                  </div>
                </div>
              </div>

            </div>
            <div id="overlay" style="text-align: center" v-show="overlay">
              <div class="ib-finish-container">
                <div class="ib-finish-top" style="margin-top: 4rem; border-bottom:none !important;">
                  <img class="img-fluid" :src="require('@/assets/images/success.png')">
                  <div class="finish-submitted">
                    Claim Logged Successfully
                  </div>
                  <div class="finish-success">View Submitted claim form in documents</div>
                </div>
                <div class="ib-action-btns mb-5">
                  <router-link :to="{ name: 'Claims' }" class="ib-btn-primary ib-btn-width ib-btn-hover mr-3">FINISH</router-link>
                  <a class="ib-btn-primary ib-btn-width ib-btn-hover" :href="document_link" target="_blank" style="padding-left: 20px;">View&nbsp;Document</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import moment from "moment";
  import loading from '@/components/Loading/Loading'
  export default{
    name: 'Claim',
    components: {
      loading
    },
    data(){
      return {
        workFlows:[],
        motorImages:[],
        inspectionImages:[],
        showLoader : false,
        mainArea : true,
        document_link: '',
        documents :[],
        back_btn: false,
        images: [],
        doc_files:{},
        claim_details:'',
        selected_claim_type: '',
        customer_self_claims: {},
        customer_nominated_claims: {},
        customer_claims: {},
        policy_type: true,
        self_policies: false,
        nav_link: 0,
        active: false,
        customer_quotation_id: 0,
        risk_id: 0,
        claim_types: {},
        type_id : 0,
        from_info: {},
        form_fields: {},
        doc_fields: {},
        form_name: '',
        files_data: [],
        overlay: false,
        tab_heading: 'Register Claim',
        MajorClass: '',
        Policies: {},
        major_classes: {},
        typeSubmit: false,
        Prev: true,
        tempPre : false,
        TypeArea: false,
        typeform1: true,
        typeSubmitTemp: true,
        typeform2: false,
        inspection_images: {},
        stepThreeMotorImages: {
          frontRight: [],
          frontCenter: [],
          frontLeft: [],
          centerRight: [],
          centerTop: [],
          centerLeft: [],
          rearRight: [],
          rearCenter: [],
          rearLeft: [],
        },
        stepThreeMotorImagesPath: {
          frontRight: [],
          frontCenter: [],
          frontLeft: [],
          centerRight: [],
          centerTop: [],
          centerLeft: [],
          rearRight: [],
          rearCenter: [],
          rearLeft: [],
        },
        j : 0,
        stepThreeMotorImagesErrors: [],
        motorWorkflow: {},
        step_1 : true,
        step_2 : false,
        step_3 : false,
        step_4 : false,
        selectedPolicy: {},
        images_count:''
      };
    },
    created: function () {
      const self = this;
      self.getData();
    },
    methods:{
      formatDate(date) {
        return moment(date, "YYYY-MM-DD").format('DD-MMM-YYYY');
      },
      async getData() {
        const self = this;
        const promises = [];

        self.showLoader = true;
        promises.push(await axios.get('customer/customer_policies_listing').then(function (resp) {
          if(resp.data.code == 200) {
            self.customer_claims = resp.data.data.policies;
            self.Policies = resp.data.data.policies.filter(x => x.status == 'issued' || x.status == 'expiring_soon');
            self.customer_claims = resp.data.data.policies.filter(x => x.status == 'issued');
            let main_classes = [];
            self.Policies.forEach(element => {
              main_classes.push(element.mainclass_name);
            });
            let filtered_main_classes = main_classes.filter((item, i, ar) => ar.indexOf(item) === i);
            self.major_classes = filtered_main_classes;
            self.MajorClass = filtered_main_classes[0];

            self.LoadClaims(self.MajorClass);
          } else {
            self.showLoader = false;
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        }));


        Promise.all(promises).then(() => {
          self.showLoader = false;
          //self.customer_claims = self.customer_self_claims;
          if (self.customer_claims.length === 0) {
            //self.customer_claims = {};
            $toast.error('No Policies Found.', { position: 'top-right' });
          }
        });
      },
      async setType(type_id) {
        const self = this;
        self.showLoader = true;
        self.stepThreeMotorImagesErrors = [];
        self.type_id = type_id;
        self.typeSubmit = false;
        self.Prev = true;
        self.tempPre = false;
        self.typeform1 = true;
        self.typeSubmitTemp = true;
        self.typeform2 = false;
        self.selected_claim_type = type_id;

        await axios.post('customer/customer_claim_fields',{ claim_type_id : self.type_id, customer_quotation_id : self.customer_quotation_id }).then(function (resp) {
          self.showLoader = false;
          if (resp.data.code == 200) {
            self.workFlows = resp.data.data.workflows;
            self.inspectionImages = resp.data.data.inspection_images;
            self.documents = resp.data.data.documents;
            if (resp.data.data.claim_forms == undefined || resp.data.data.claim_forms.length == 0) {
              self.typeSubmitTemp = false;
              self.form_fields = {};
              self.form_name = '';
              $toast.error('Claim Form Fields Not Found', {position: 'top-right'});
              return false;
            }
            self.typeSubmitTemp = true;
            self.form_name = Object.keys(resp.data.data.claim_forms)[0];
            self.form_fields = resp.data.data.claim_forms[self.form_name].custom_fields;
            self.doc_fields = resp.data.data.documents;
            if (self.selectedPolicy.subclass_name.toLowerCase() == 'motor cycle') {
              self.stepThreeMotorImages = [];
            }
            if (resp.data.data.inspection_images.length > 0) {
              self.inspection_images = resp.data.data.inspection_images[0];
            }
            Object.entries(self.doc_fields).forEach(([value, index]) => {
              self.doc_files[index.field_name] = [];
            });

            let j = 0;
            $.each(resp.data.data.workflows.Claims, function (key, value) {
              if(key == 'Claims Intimation'){
                $.each(value, function (_key, _value) {
                  if (_value.key == 'upload-images' && _value.customer_app == 1){
                    j=1;
                    self.j=1;
                  }
                });
              }
            });
            if (j == 0){
              self.typeSubmit = true;
              self.typeform2 = false;
              self.typeSubmitTemp = false;
              self.typeform1 = true;
            }
            self.from_info = resp.data.data.claim_forms;
          } else {
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      },
      ShowNextForm() {
        const self = this;
        // self.typeform1 = !self.typeform1;
        // self.typeform2 = !self.typeform2;
        // self.nav_link = self.nav_link + 1;

        if(self.stepThreeMotorImages.length > 0 || self.motorImages.length > 0){
          self.nav_link = self.nav_link + 1;
          self.next_step(1);
        }
        self.typeSubmit = !self.typeSubmit;
        self.typeSubmitTemp = !self.typeSubmitTemp;
      },
      LoadClaims(class_name) {
        const self = this;
        self.claim_types = {};
        self.MajorClass = class_name;
        self.customer_claims = self.Policies.filter(x => x.mainclass_name.replace(/ /g,"_").toLowerCase() == class_name.replace(/ /g,"_").toLowerCase());
      },
      submitClaimForm: function (e) {
        const self = this;
        e.preventDefault();
        if (self.j == 0){
          self.next_step(1, 'Upload Document');
        }else{
          self.stepThreeMotorImagesErrors = [];

          if(self.form_name != 'Theft_Claim') {
            Object.entries(self.stepThreeMotorImages).forEach(([key, field]) => {
              if(field.length <= 0) {
                self.stepThreeMotorImagesErrors.push({
                  field: key,
                  message: key.replace(/_/g,' ') + ' required'
                });
              }
            });
          }

          if (self.stepThreeMotorImagesErrors.length > 0) {
            return false;
          } else {
            self.next_step(1, 'Upload Document');
          }
        }
      },
      async set_quotation_id(customer_quotation_id, status, risk_id, policy) {
        const self = this;
        if(status.toLowerCase() == 'expired') {
          $toast.error('Cannot Do Claim For Expired Policy', { position: 'top-right' });
          return false;
        }
        self.selectedPolicy = policy;
        self.showLoader = true;
        self.customer_quotation_id = customer_quotation_id;
        self.risk_id = risk_id;
        self.stepThreeMotorImages.frontRight = [];
        self.stepThreeMotorImages.frontCenter = [];
        self.stepThreeMotorImages.frontLeft = [];
        self.stepThreeMotorImages.centerRight = [];
        self.stepThreeMotorImages.centerTop = [];
        self.stepThreeMotorImages.centerLeft = [];
        self.stepThreeMotorImages.rearRight = [];
        self.stepThreeMotorImages.rearCenter = [];
        self.stepThreeMotorImages.rearLeft = [];

        self.stepThreeMotorImagesPath.frontRight = [];
        self.stepThreeMotorImagesPath.frontCenter = [];
        self.stepThreeMotorImagesPath.frontLeft = [];
        self.stepThreeMotorImagesPath.centerRight = [];
        self.stepThreeMotorImagesPath.centerTop = [];
        self.stepThreeMotorImagesPath.centerLeft = [];
        self.stepThreeMotorImagesPath.rearRight = [];
        self.stepThreeMotorImagesPath.rearCenter = [];
        self.stepThreeMotorImagesPath.rearLeft = [];

        await axios.get('customer/claim_types?customer_quotation_id=' + customer_quotation_id ).then(function (resp) {
          self.showLoader = false;
          if (resp.data.code == 200) {
            self.claim_types = resp.data.data;
            if (self.claim_types.length === 0) {
              $toast.error('No Type Found Against This Policy', {position: 'top-right'});
            } else {
              self.next_step(1);
            }
          } else {
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      },
      next_step:function(event, heading = 'Register Claim'){
        const self = this;
        self.tab_heading = heading;
        var obj = document.getElementsByClassName('nav-link-local');
        var tab = document.getElementsByClassName('tab-pane');
        obj[self.nav_link].classList.remove("active");
        tab[self.nav_link].classList.remove("active", "show");
        self.policy_type = true;
        self.self_policies = false;
        self.back_btn = true;
        self.step_1 = false;
        self.step_2 = false;
        self.step_3 = false;
        self.step_4 = false;
        if (event == 1) {

          if (self.nav_link + 1 == 1) {
            self.step_2 = true;
            self.setType(self.claim_types[0].id);
            self.TypeArea = !self.TypeArea;
            if(self.documents.length > 0 && self.MajorClass == 'health'){
              self.nav_link = self.nav_link + 1;
            }
            if(self.MajorClass == 'motor' && self.inspectionImages.length > 0){
              self.typeform1 = false;
              self.typeform2 = true;
            }
          } else if(self.nav_link + 1 == 2) {
            self.TypeArea = false;
            self.step_3 = true;
            // if(self.documents.length > 0){
            //   self.nav_link = self.nav_link + 1;
            // }
          }
          obj[self.nav_link+1].classList.add("active");
          tab[self.nav_link+1].classList.add("active", "show");
        } else if(event == 0) {
          if (self.nav_link - 1 == 0) {
            self.step_1 = false;
            self.step_2 = false;
            self.TypeArea = true;
            self.nav_link = self.nav_link - 1;
            self.typeSubmitTemp = true;
            self.typeSubmit = false;
          }
          obj[self.nav_link+1].classList.add("active");
          tab[self.nav_link+1].classList.add("active", "show");
        }

        if (self.nav_link == 0) {
          self.back_btn = false;
          self.show_policies();
        }
      },
      uploadImage(e, field_name) {
        let self = this;
        var selectedFiles = e.target.files;
        // self.doc_files[field_name] = [];
        console.log('selected_files',field_name);
        for (let i = 0; i < selectedFiles.length; i++) {
          self.doc_files[field_name].push(selectedFiles[i]);
          self.$forceUpdate();
        }
      },
      removeUploadedFile(index, fieldName) {
        const self = this;
        self.doc_files[fieldName].splice(index, 1);
        self.doc_files.push({ test: 'test' });
        self.doc_files.splice(-1, 1);
      },
      async submit_form_data() {
        const self = this;
        self.showLoader = true;
        var check = 0;
        var formData = new FormData();
        // formData.append('customer_quotation_id', self.customer_quotation_id);
        formData.append('claim_details',self.claim_details);
        formData.append('section_id', self.form_fields[0].section_id);
        formData.append('claim_type_id', self.type_id);
        formData.append('risk_id', self.risk_id);
        if (self.selectedPolicy.subclass_name == 'Motor Cycle'){
          Object.entries(self.stepThreeMotorImages).forEach(([key, value])=>{
            formData.append(self.inspection_images.field_name + '[]' , value);
          });
        }else{
          Object.entries(self.stepThreeMotorImagesPath).forEach(([key, value])=>{
            value.forEach(element =>{
              formData.append(self.inspection_images.field_name + '[]' , element);
            });
          });
        }
        Object.entries(self.doc_files).forEach(([key, value]) => {;
          value.forEach(element => {
            formData.append(key + '[]', element);
          });
          if (value.length === 0) {
            check =1;
          }
        });
        if (check === 1) {
          $toast.error('Please Select Required Documents', {position: 'top-right'});
          self.showLoader = false;
          return false;
        } else {
          await axios.post('customer/claims/create',formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(function (resp) {
            self.showLoader = false;
            if (resp.data.code == 200) {
              self.document_link = resp.data.data.document_link;
              self.next_step(1, 'Summary');
              self.back_btn = false;
              self.overlay = true;
              self.mainArea = false;
              $toast.success(resp.data.message, {position: 'top-right'});
            } else {
              $toast.error(resp.data.message, {position: 'top-right'});
              return false;
            }
          }).catch(function (error) {
            self.showLoader = false;
            if(error.errors != undefined) {
              error.errors.forEach(element => {
                $toast.error(element.message, { position: 'top-right' });
              });
            } else {
              $toast.error(error.message, { position: 'top-right' });
            }
          });
        }
      },
      uploadStepThreeBikeImages: function (e){
        let self = this;
        if(e.target.files.length > 0) {
          var selectedFiles = e.target.files;
        } else {
          return false;
        }

        if (self.stepThreeMotorImages.length >= self.inspection_images.max_images){
          $toast.error('Maximum '+ self.inspection_images.max_images +' Motor Cycle images are required ', { position: 'top-right' });
          return false;
        }
        if(selectedFiles[0]['type'].split('/')[0] != 'image') {
          $toast.error('Only image files are accepted', { position: 'top-right' });
        } else if (selectedFiles[0].size > 5000000) {
          $toast.error('Upload file less than 5Mb', { position: 'top-right' });
          return false;
        } else {
          self.stepThreeMotorImages.push(selectedFiles[0]);
          const file = e.target.files[0];
          var url = URL.createObjectURL(file);

        }

      },
      uploadStepThreeMotorImages (e, field_name) {
        let self = this;

        if(e.target.files.length > 0) {
          var selectedFiles = e.target.files;
        } else {
          return false;
        }
        let count = 0;
        for(var key in self.stepThreeMotorImages){
          count = count + self.stepThreeMotorImages[key].length;
        }

        if (count >= self.inspection_images.max_images){
          $toast.error('Maximum '+ self.inspection_images.max_images +' vehicle images are required ', { position: 'top-right' });
          return false;
        }
        self.stepTwoDocumentsErrors = [];
        if(selectedFiles[0]['type'].split('/')[0] != 'image') {
          $toast.error('Only image files are accepted', { position: 'top-right' });
        } else if (selectedFiles[0].size > 5000000) {
          $toast.error('Upload file less than 5Mb', { position: 'top-right' });
          return false;
        } else {
          console.log('----');
          console.log(field_name);
          // self.stepThreeMotorImagesPath[field_name] = [];
          self.stepThreeMotorImages[field_name].push(selectedFiles[0]);
          self.motorImages = self.stepThreeMotorImages[field_name];
          self.$forceUpdate();
          const file = e.target.files[0];
          var url = URL.createObjectURL(file);
          $('#_'+field_name).attr('src', url);
          self.stepThreeMotorImagesPath[field_name].push(url);
        }
      },
    }
  }
</script>

<style scoped>
  .data-row p {
    color :#5b6770;
  }
  table > tbody > tr, .data-row {
    margin: 10px 0;
    padding: 20px 30.7px 20px 15px;
    border-radius: 10px;
    border: solid 1px #dedada;
    background-color: #ffffff;
  }
  .data-row .action-area {
    text-align: right;
  }
  .data-row .action-area i {
    width: 7.9px;
    height: 14.6px;
    color: #5b6770;
  }
  .data-row .claim-row-sub-heading {
    color: #a9adaf;
  }
  .data-row .claim-row-sub-desc {
    color: #5b6770;
  }
  .data-row .status-danger {
    background-color: rgba(30, 203, 16, 0.09);
    font-size: 12px;
    font-stretch: normal;
    font-style: normal;
    color: #1ecb10;
    letter-spacing: normal;
  }
  .data-row .status {
    margin: 10px 61.3px 10px 52px;
    padding: 6px 24px;
    border-radius: 6px;
    font-family: "Futura PT";
  }
  .data-row .claim-row-data {
    font-family: "Futura PT";
    font-size: 17px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 8px;
    letter-spacing: normal;
    text-align: left;
  }
  .data-row .claim-row-heading {
    font-family: "Futura PT";
    font-size: 22px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.32;
    letter-spacing: normal;
    text-align: left;
    color: #5b6770;
  }
  /* table > tbody > tr > th > img,.data-img img {
    width: 79px;
    height: 66px;
    border-radius: 11px;
    border: 1px solid gainsboro;
  }
  .position-relative .small-icon {
    border-radius: 50%;
    position: absolute;
    width: 25px;
    height: 25px;
    top: -20px;
    right: 0px;
  } */
  .in-listing-img {
    width: 79px;
    height: 66px;
    background-color: #ecf3f5;
    border-radius: 11px;
    border: 1px solid gainsboro;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }
  .in-listing-img img{
    width: 100% !important;
    max-width: 70px !important;
    max-height: 60px !important;
    height: auto !important;
  }

  .position-relative-box {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    border: 1px solid gainsboro;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    position: absolute;
    bottom: -10px;
    right: -10px;
  }
  .position-relative-box img{
    width: 100% !important;
    max-width: 23px !important;
    height: auto !important;
  }
  table.claim-listing {
    width: 100%;
    margin: 0 auto;
    font-family: Arial, sans-serif;
    border-collapse: separate;
    border-spacing: 0 10px;
  }
  table.claim-listing td {
    height: 100px !important;
    vertical-align: middle;
    text-align: center;
    position: relative;
  }
  @media (max-width:668px) {
    table.claim-listing td:not(:first-child) {
      height: 60px !important;
    }
    table.claim-listing tbody td:first-child {
      height: auto !important;
    }
  }
  table.claim-listing td:last-child:after {
    content: none;
  }
  table.claim-listing tbody td {
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
    cursor: pointer;
  }
  @media (min-width:669px) {
    table.claim-listing tbody td:first-child {
      border-left: 1px solid #eee;
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
    }
    table.claim-listing tbody td:last-child {
      border-right: 1px solid #eee;
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
    }
    table.claim-listing tbody tr {
      box-shadow: 0 3px 26px 0 rgba(0, 0, 0, 0.08);
    }
  }
  .jbl-table-heading {
    font-family: "Avenir Medium";
    font-weight: 500;
    text-align: left !important;
    font-size: 19px;
    color: #5b6770;
  }
  /* .jbl-table-heading span {
    font-size: 19px;
    font-size: 10px;
    color: #5b6770;
    font-weight: normal !important;
  } */
  .jbl-table-heading span {
    font-weight: normal !important;
    font-size: 10px !important;
    font-weight: 500 !important;
    color: #ef7c94 !important;
  }
  .jbl-table-heading small {
    font-weight: normal !important;
    font-size: 11px !important;
    font-weight: 500 !important;
    color: #ef7c94 !important;
  }
  .jbl-date-td {
    font-family: "Avenir Medium";
    font-size: 19px;
    font-weight: 500;
    text-align: left;
    color: #5b6770;
  }
  .jbl-date-heading {
    color: #ef7c94 !important;
    font-family: "Avenir Book";
    font-size: 13px;
    text-align: left;
  }
  table.claim-listing .fa-chevron-right {
    padding-right: 2rem;
    color: #5b6770;
  }
  .jbl-flex-td {
    display: flex;
    flex-direction: column;
  }
  @media (min-width:668px) and (max-width:992px) {
    .jbl-table-heading {
      font-size: 14px;
    }
    .jbl-date-td {
      font-family:"Futura PT Medium";
      font-size: 12px;
    }
    table.claim-listing .fa-chevron-right {
      padding-right: 1rem;
      color: #5b6770;
    }
  }
  .d2c-main-classes {
    background-color: #def3f7;
    border-radius: 31px;
    max-width: fit-content;
    margin: 1px 0 30px;
  }
  .d2c-class-btn {
    display: inline-block;
    margin-bottom: 0;
    text-align: center;
    vertical-align: middle;
    touch-action: manipulation;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    white-space: nowrap;
    padding: 6px 12px;
    border: 1px solid transparent;
    border-radius: 4px;
    height: 61px;
    margin: 0 0 1px;
    border-radius: 31px;
    background-color: #def3f7;
    font-family: "Avenir Medium";
    font-size: 16px;
    font-weight: 500;
    line-height: 1.38;
    color: #4c505d;
    transition: all .3s ease-in;
  }
  .d2c-class-btn:hover {
    background-color: #049cbd;
    color: white;
  }
  .d2c-class-btn:focus, .d2c-class-btn:active, .d2c-class-btn.active {
    outline: none !important;
    background-color: #049cbd;
    color: white;
  }
  /* .d2c-main-classes .d2c-class-btn::after {
    content: '';
    width: 0;
    height: 35px;
    border: solid 1px #049ab3;
    position: relative;
    right: -16px;
  }
  .d2c-main-classes.d2c-class-tabs button.d2c-class-btn::after {
    content: '';
    border: none !important;
  }
  .d2c-main-classes button:last-child.d2c-class-btn::after {
    content: '';
    border: none !important;
  } */
  .nex-Page-Link .fa-chevron-right {
    color: #aeccd6 !important;
    font-weight: normal !important;
  }
  @media(max-width:550px){
    .d2c-class-btn{
      padding: 6px 22px !important;
      width: max-content !important;
      font-size: 12px !important;
    }
  }
  .multistep-box label:not(.css-label,.css-label-checked) {
    display: block !important;
    text-align: left !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/Claims/Claim.vue